import Repository from '@/repositories/RepositoryFactory';
import ENUM from '../../enums/APISTATE';
import store from '../';

const CirclesRepository = Repository.get('circles');

export default ({
  namespaced: true,
  state: {
    apiState: ENUM.INIT,
    apiStateCircleForGroup: ENUM.INIT,
    circles: [],
    circlesForGroup: [],
    circle: {}
  },
  mutations: {
    setApiState: (state, apiState) => {
      state.apiState = apiState;
    },
    setCircleForGroupApiState: (state, apiState) => {
      state.apiStateCircleForGroup = apiState;
    },
    setCircle(state, response) {
      const { data } = response;
      state.circle = data;
      state.apiState = ENUM.LOADED;
    },
    setCircles(state, response) {
      const { data } = response;
      state.circles = data;
      state.apiState = ENUM.LOADED;
    },
    setCircleForGroup(state, response) {
      const { data } = response;
      state.circlesForGroup = data;
    },
    initialized(state, { circles }) {
      state.circles = circles;
    }
  },
  actions: {
    loadAllCircles({commit}) {
      return new Promise((resolve, reject) => {
        CirclesRepository.getAll().then((response) => {
          commit('setCircles', response);
          resolve();
        }).catch((error) => {
          console.error(error);
          commit('setApiState', ENUM.ERROR);
          reject();
        });
      });
    },

    loadCirclesForPeriod({commit}, {startDate, endDate, teamFilter}) {
      return new Promise((resolve, reject) => {
        CirclesRepository.getForPeriod(startDate, endDate, teamFilter).then((response) => {
          commit('setCircles', {data: response}); // not tested (data extracted in repository)
          resolve();
        }).catch((error) => {
          console.error(error);
          commit('setApiState', ENUM.ERROR);
          reject();
        });
      });
    },

    loadCirclesCurrentWeek({commit}) {
      return new Promise((resolve, reject) => {
        CirclesRepository.getCirclesCurrentWeek().then((response) => {
          commit('setCircles', response)
          resolve();
        }).catch((error) => {
          console.error(error);
          commit('setApiState', ENUM.ERROR);
          reject();
        })
      });
    },
    async loadCircles({ commit }) {
      commit('setApiState', ENUM.LOADING);
      try {
        commit('setCircles', await CirclesRepository.getAll());
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async getPeriods({ commit }, {startDate, endDate, teamFilter}) {
      commit('setApiState', ENUM.LOADING);
      try {
        commit('setCircles', await CirclesRepository.getPeriods());
      }
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async getCircle({ commit }, id) {
      commit('setApiState', ENUM.LOADING);
      
      try {
        const circle = await CirclesRepository.getCircle(id);
        commit("setCircle", circle);
        commit('setApiState', ENUM.LOADED);
        return circle;
      } 
      catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async getCircleForGroup({ commit }, dto) {
      commit('setCircleForGroupApiState', ENUM.LOADING);
      
      try {
        const circle = await CirclesRepository.getCircleForGroup(dto.groupId);
        commit("setCircleForGroup", circle);
        commit('setCircleForGroupApiState', ENUM.LOADED);
        return circle;
      } 
      catch (error) {
        console.error(error);
        commit('setCircleForGroupApiState', ENUM.ERROR);
      }
    },
    async createCircle({ commit }, circle) {
      commit('setApiState', ENUM.LOADING);

      try {
        await CirclesRepository.create(circle);
        commit('setApiState', ENUM.LOADED);
      } catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    },
    async updateCircle({ commit }, circle) {
      commit('setApiState', ENUM.LOADING);

      try {
        await CirclesRepository.update(circle);
        commit('setApiState', ENUM.LOADED);
      } catch (error) {
        console.error(error);
        commit('setApiState', ENUM.ERROR);
      }
    }
  },
  getters: {
    circleIsLoading(state) {
      return state.apiState === ENUM.LOADING;
    },
    circleForGroupIsLoading(state) {
      return state.apiStateCircleForGroup === ENUM.LOADING;
    },
    circleApiState(state) {
      return state.apiState;
    },
    circle(state) {
      return state.circle;
    },
    circles(state) { 
      return state.circles; 
    },
    circlesForGroup(state) { 
      return state.circlesForGroup; 
    }
  }
});
